import { lazyPage } from '@/lib/lazy-load'

const MyProfilePage = lazyPage(() => import('./MyProfilePage'))
export default MyProfilePage
